import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const EndocrineOverviewDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp11a1 = getGenePalette(geneColors.CYP11A1);
  const akr1c = getGenePalette(geneColors.AKR1C);
  const akr1c1 = getGenePalette(geneColors.AKR1C1);
  const srd5a1 = getGenePalette(geneColors.SRD5A1);
  const akr1d1 = getGenePalette(geneColors.AKR1D1);
  const akr1c2 = getGenePalette(geneColors.AKR1C2);
  const fkbp5 = getGenePalette(geneColors.FKBP5);
  const serpina6 = getGenePalette(geneColors.SERPINA6);
  const hsd3b1 = getGenePalette(geneColors.HSD3B1);
  const cyp17a1 = getGenePalette(geneColors.CYP17A1);
  const cyp21a2 = getGenePalette(geneColors.CYP21A2);
  const cyp11b1 = getGenePalette(geneColors.CYP11B1);
  const hsd11b1 = getGenePalette(geneColors.HSD11B1);
  const shbg = getGenePalette(geneColors.SHBG);
  const cyp19a1 = getGenePalette(geneColors.CYP19A1);
  const ugt2b15 = getGenePalette(geneColors.UGT2B15);
  const hsd17b1 = getGenePalette(geneColors.HSD17B1);
  const cyp1a1 = getGenePalette(geneColors.CYP1A1);
  const cyp1b1 = getGenePalette(geneColors.CYP1B1);
  const esr1 = getGenePalette(geneColors.ESR1);
  const esr2 = getGenePalette(geneColors.ESR2);
  const comt = getGenePalette(geneColors.COMT);
  const ugt_sult = getGenePalette(geneColors["UGT/SULT"]);
  const nqo1 = getGenePalette(geneColors.NQO1);
  const cyp3a4 = getGenePalette(geneColors.CYP3A4);
  const hsd17b2 = getGenePalette(geneColors.HSD17B2);
  const ar = getGenePalette(geneColors.AR);
  const srd5a2 = getGenePalette(geneColors.SRD5A2);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_224300)">
        <rect width={1024} height={1344} transform="translate(0 204)" fill="white" />
        <g id="endocrine-overview-diagram">
          <rect width={1024} height={1344} transform="translate(0 204)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M192.233 540.688L200.161 539.113L194.833 533.035L192.233 540.688ZM408.546 352.027L409.072 351.565L408.149 350.512L407.623 350.974L408.084 351.5L408.546 352.027ZM196.97 536.535L197.432 537.062L408.546 352.027L408.084 351.5L407.623 350.974L196.509 536.009L196.97 536.535Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M533.167 709.654L540.683 706.679L534.348 701.658L533.167 709.654ZM640.05 575.933L640.485 575.384L639.388 574.515L638.953 575.063L639.502 575.498L640.05 575.933ZM537.081 704.717L537.629 705.152L640.05 575.933L639.502 575.498L638.953 575.063L536.532 704.282L537.081 704.717Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M498.169 571.568L505.76 568.791L499.56 563.605L498.169 571.568ZM540.887 521.579L541.336 521.042L540.263 520.144L539.813 520.681L540.35 521.13L540.887 521.579ZM502.211 566.735L502.748 567.184L540.887 521.579L540.35 521.13L539.813 520.681L501.674 566.286L502.211 566.735Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_17ohpreg-hsd3b1">
            <path
              id="Vector_17ohpreg-hsd3b1"
              d="M565.000 473.000L566.701 465.183L572.620 470.564ZM567.737 469.246L584.630 450.664L585.370 451.336L568.477 469.919Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_5"
              d="M120 892.042L127 896.083V888L120 892.042ZM203.3 892.742H204V891.342H203.3V892.042V892.742ZM126.3 892.042V892.742H203.3V892.042V891.342H126.3V892.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M566 1128.04L573 1132.08V1124L566 1128.04ZM713.3 1128.74H714V1127.34H713.3V1128.04V1128.74ZM572.3 1128.04V1128.74H713.3V1128.04V1127.34H572.3V1128.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <mask id="path-27-inside-2_18293_224300" fill="white">
              <path d="M544 1112H725V1156H544V1112Z" />
            </mask>
            <path
              d="M725 1156V1157.4H726.4V1156H725ZM725 1112H723.6V1156H725H726.4V1112H725ZM725 1156V1154.6H544V1156V1157.4H725V1156Z"
              fill="#1A1A1A"
              mask="url(#path-27-inside-2_18293_224300)"
            />
          </g>
          <g id="lines_7">
            <mask id="path-29-inside-3_18293_224300" fill="white">
              <path d="M552 1109H732V1164H552V1109Z" />
            </mask>
            <path
              d="M552 1164H550.6V1165.4H552V1164ZM732 1164V1162.6H552V1164V1165.4H732V1164ZM552 1164H553.4V1109H552H550.6V1164H552Z"
              fill="#1A1A1A"
              mask="url(#path-29-inside-3_18293_224300)"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_7"
              d="M588 879.042L595 883.083V875L588 879.042ZM624.3 879.742H625V878.342H624.3V879.042V879.742ZM594.3 879.042V879.742H624.3V879.042V878.342H594.3V879.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_8"
              d="M120.7 876.342H120V877.742H120.7V877.042V876.342ZM204 877.042L197 873V881.083L204 877.042ZM120.7 877.042V877.742H197.7V877.042V876.342H120.7V877.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_9"
              d="M561.7 1102.34H561V1103.74H561.7V1103.04V1102.34ZM717 1103.04L710 1099V1107.08L717 1103.04ZM561.7 1103.04V1103.74H710.7V1103.04V1102.34H561.7V1103.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_10"
              d="M710.2 1162.34H709.5V1163.74H710.2V1163.04V1162.34ZM714.5 1163.04L707.5 1159V1167.08L714.5 1163.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_12">
            <path
              id="Vector_11"
              d="M571.8 1155.74L572.5 1155.74L572.5 1154.34L571.8 1154.34L571.8 1155.04L571.8 1155.74ZM567.5 1155.04L574.5 1159.08L574.5 1151L567.5 1155.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_13">
            <path
              id="Vector_12"
              d="M588.7 863.342H588V864.742H588.7V864.042V863.342ZM629 864.042L622 860V868.083L629 864.042ZM588.7 864.042V864.742H622.7V864.042V863.342H588.7V864.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_14">
            <path
              id="Vector_13"
              d="M901.742 861.7L901.742 861L900.342 861L900.342 861.7L901.042 861.7L901.742 861.7ZM901.042 944L905.083 937L897 937L901.042 944ZM901.042 861.7L900.342 861.7L900.342 937.7L901.042 937.7L901.742 937.7L901.742 861.7L901.042 861.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_15">
            <path
              id="Vector_14"
              d="M829.742 861.7L829.742 861L828.342 861L828.342 861.7L829.042 861.7L829.742 861.7ZM829.042 902L833.083 895L825 895L829.042 902ZM829.042 861.7L828.342 861.7L828.342 895.7L829.042 895.7L829.742 895.7L829.742 861.7L829.042 861.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_16">
            <path
              id="Vector_15"
              d="M829.742 730.7C829.742 730.314 829.428 730 829.042 730C828.655 730 828.342 730.314 828.342 730.7L829.042 730.7L829.742 730.7ZM829.041 846L833.083 839L825 839L829.041 846ZM828.342 732.759C828.342 733.146 828.655 733.459 829.042 733.459C829.428 733.459 829.742 733.146 829.742 732.759L829.042 732.759L828.342 732.759ZM829.742 736.877C829.742 736.49 829.428 736.177 829.042 736.177C828.655 736.177 828.342 736.49 828.342 736.877L829.042 736.877L829.742 736.877ZM828.342 740.995C828.342 741.381 828.655 741.695 829.042 741.695C829.428 741.695 829.742 741.381 829.742 740.995L829.042 740.995L828.342 740.995ZM829.742 745.113C829.742 744.726 829.428 744.413 829.042 744.413C828.655 744.413 828.342 744.726 828.342 745.113L829.042 745.113L829.742 745.113ZM828.342 749.231C828.342 749.617 828.655 749.931 829.042 749.931C829.428 749.931 829.742 749.617 829.742 749.231L829.042 749.231L828.342 749.231ZM829.742 753.348C829.742 752.962 829.428 752.648 829.042 752.648C828.655 752.648 828.342 752.962 828.342 753.348L829.042 753.348L829.742 753.348ZM828.342 757.466C828.342 757.853 828.655 758.166 829.042 758.166C829.428 758.166 829.742 757.853 829.742 757.466L829.042 757.466L828.342 757.466ZM829.742 761.584C829.742 761.198 829.428 760.884 829.042 760.884C828.655 760.884 828.342 761.198 828.342 761.584L829.042 761.584L829.742 761.584ZM828.342 765.702C828.342 766.089 828.655 766.402 829.042 766.402C829.428 766.402 829.742 766.089 829.742 765.702L829.042 765.702L828.342 765.702ZM829.742 769.82C829.742 769.433 829.428 769.12 829.042 769.12C828.655 769.12 828.342 769.433 828.342 769.82L829.042 769.82L829.742 769.82ZM828.342 773.938C828.342 774.324 828.655 774.638 829.042 774.638C829.428 774.638 829.742 774.324 829.742 773.938L829.042 773.938L828.342 773.938ZM829.742 778.056C829.742 777.669 829.428 777.356 829.042 777.356C828.655 777.356 828.342 777.669 828.342 778.056L829.042 778.056L829.742 778.056ZM828.342 782.173C828.342 782.56 828.655 782.873 829.042 782.873C829.428 782.873 829.742 782.56 829.742 782.173L829.042 782.173L828.342 782.173ZM829.742 786.291C829.742 785.905 829.428 785.591 829.042 785.591C828.655 785.591 828.342 785.905 828.342 786.291L829.042 786.291L829.742 786.291ZM828.342 790.409C828.342 790.796 828.655 791.109 829.042 791.109C829.428 791.109 829.742 790.796 829.742 790.409L829.042 790.409L828.342 790.409ZM829.742 794.527C829.742 794.14 829.428 793.827 829.042 793.827C828.655 793.827 828.342 794.14 828.342 794.527L829.042 794.527L829.742 794.527ZM828.342 798.645C828.342 799.031 828.655 799.345 829.042 799.345C829.428 799.345 829.742 799.031 829.742 798.645L829.042 798.645L828.342 798.645ZM829.742 802.763C829.742 802.376 829.428 802.063 829.042 802.063C828.655 802.063 828.342 802.376 828.342 802.763L829.042 802.763L829.742 802.763ZM828.342 806.881C828.342 807.267 828.655 807.581 829.042 807.581C829.428 807.581 829.742 807.267 829.742 806.881L829.042 806.881L828.342 806.881ZM829.742 810.998C829.742 810.612 829.428 810.298 829.042 810.298C828.655 810.298 828.342 810.612 828.342 810.998L829.042 810.998L829.742 810.998ZM828.342 815.116C828.342 815.503 828.655 815.816 829.042 815.816C829.428 815.816 829.742 815.503 829.742 815.116L829.042 815.116L828.342 815.116ZM829.742 819.234C829.742 818.848 829.428 818.534 829.042 818.534C828.655 818.534 828.342 818.848 828.342 819.234L829.042 819.234L829.742 819.234ZM828.341 823.352C828.341 823.739 828.655 824.052 829.041 824.052C829.428 824.052 829.741 823.739 829.741 823.352L829.041 823.352L828.341 823.352ZM829.741 827.47C829.741 827.083 829.428 826.77 829.041 826.77C828.655 826.77 828.341 827.083 828.341 827.47L829.041 827.47L829.741 827.47ZM828.341 831.588C828.341 831.974 828.655 832.288 829.041 832.288C829.428 832.288 829.741 831.974 829.741 831.588L829.041 831.588L828.341 831.588ZM829.741 835.706C829.741 835.319 829.428 835.006 829.041 835.006C828.655 835.006 828.341 835.319 828.341 835.706L829.041 835.706L829.741 835.706ZM828.341 839.823C828.341 840.21 828.655 840.523 829.041 840.523C829.428 840.523 829.741 840.21 829.741 839.823L829.041 839.823L828.341 839.823ZM829.741 843.941C829.741 843.555 829.428 843.241 829.041 843.241C828.655 843.241 828.341 843.555 828.341 843.941L829.041 843.941L829.741 843.941ZM829.042 730.7L828.342 730.7L828.342 732.759L829.042 732.759L829.742 732.759L829.742 730.7L829.042 730.7ZM829.042 736.877L828.342 736.877L828.342 740.995L829.042 740.995L829.742 740.995L829.742 736.877L829.042 736.877ZM829.042 745.113L828.342 745.113L828.342 749.231L829.042 749.231L829.742 749.231L829.742 745.113L829.042 745.113ZM829.042 753.348L828.342 753.348L828.342 757.466L829.042 757.466L829.742 757.466L829.742 753.348L829.042 753.348ZM829.042 761.584L828.342 761.584L828.342 765.702L829.042 765.702L829.742 765.702L829.742 761.584L829.042 761.584ZM829.042 769.82L828.342 769.82L828.342 773.938L829.042 773.938L829.742 773.938L829.742 769.82L829.042 769.82ZM829.042 778.056L828.342 778.056L828.342 782.173L829.042 782.173L829.742 782.173L829.742 778.056L829.042 778.056ZM829.042 786.291L828.342 786.291L828.342 790.409L829.042 790.409L829.742 790.409L829.742 786.291L829.042 786.291ZM829.042 794.527L828.342 794.527L828.342 798.645L829.042 798.645L829.742 798.645L829.742 794.527L829.042 794.527ZM829.042 802.763L828.342 802.763L828.342 806.881L829.042 806.881L829.742 806.881L829.742 802.763L829.042 802.763ZM829.042 810.998L828.342 810.998L828.342 815.116L829.042 815.116L829.742 815.116L829.742 810.998L829.042 810.998ZM829.042 819.234L828.342 819.234L828.341 823.352L829.041 823.352L829.741 823.352L829.742 819.234L829.042 819.234ZM829.041 827.47L828.341 827.47L828.341 831.588L829.041 831.588L829.741 831.588L829.741 827.47L829.041 827.47ZM829.041 835.706L828.341 835.706L828.341 839.823L829.041 839.823L829.741 839.823L829.741 835.706L829.041 835.706Z"
              fill="#818181"
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_16"
              d="M816.742 819.7C816.742 819.314 816.428 819 816.042 819C815.655 819 815.342 819.314 815.342 819.7L816.042 819.7L816.742 819.7ZM816.042 846L820.083 839L812 839L816.042 846ZM815.342 821.892C815.342 822.278 815.655 822.592 816.042 822.592C816.428 822.592 816.742 822.278 816.742 821.892L816.042 821.892L815.342 821.892ZM816.742 826.275C816.742 825.889 816.428 825.575 816.042 825.575C815.655 825.575 815.342 825.889 815.342 826.275L816.042 826.275L816.742 826.275ZM815.342 830.659C815.342 831.045 815.655 831.359 816.042 831.359C816.428 831.359 816.742 831.045 816.742 830.659L816.042 830.659L815.342 830.659ZM816.742 835.042C816.742 834.655 816.428 834.342 816.042 834.342C815.655 834.342 815.342 834.655 815.342 835.042L816.042 835.042L816.742 835.042ZM815.342 839.425C815.342 839.812 815.655 840.125 816.042 840.125C816.428 840.125 816.742 839.812 816.742 839.425L816.042 839.425L815.342 839.425ZM816.742 843.809C816.742 843.422 816.428 843.109 816.042 843.109C815.655 843.109 815.342 843.422 815.342 843.809L816.042 843.809L816.742 843.809ZM816.042 819.7L815.342 819.7L815.342 821.892L816.042 821.892L816.742 821.892L816.742 819.7L816.042 819.7ZM816.042 826.275L815.342 826.275L815.342 830.659L816.042 830.659L816.742 830.659L816.742 826.275L816.042 826.275ZM816.042 835.042L815.342 835.042L815.342 839.425L816.042 839.425L816.742 839.425L816.742 835.042L816.042 835.042Z"
              fill="#818181"
            />
          </g>
          <g id="lines_18">
            <path
              id="Vector_17"
              d="M354.044 728.037L361.635 725.26L355.434 720.075L354.044 728.037ZM460.712 601.579L461.161 601.042L460.087 600.144L459.638 600.681L460.175 601.13L460.712 601.579ZM358.086 723.204L358.623 723.653L460.712 601.579L460.175 601.13L459.638 600.681L357.549 722.755L358.086 723.204Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_19">
            <path
              id="Vector_18"
              d="M312.973 781.486L320.564 778.709L314.363 773.524L312.973 781.486ZM349.768 738.579L350.217 738.042L349.144 737.144L348.694 737.681L349.231 738.13L349.768 738.579ZM317.014 776.654L317.551 777.103L349.768 738.579L349.231 738.13L348.694 737.681L316.477 776.205L317.014 776.654Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_20">
            <path
              id="Vector_19"
              d="M245.849 859.864L251.247 853.848L243.338 852.181L245.849 859.864ZM253.403 827.424L253.547 826.739L252.177 826.451L252.033 827.136L252.718 827.28L253.403 827.424ZM247.148 853.699L247.833 853.844L253.403 827.424L252.718 827.28L252.033 827.136L246.463 853.555L247.148 853.699Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_21">
            <path
              id="Vector_20"
              d="M495.042 710L499.083 703L491 703L495.042 710ZM495.741 608.7L495.741 608L494.341 608L494.341 608.7L495.041 608.7L495.741 608.7ZM495.042 703.7L495.742 703.7L495.741 608.7L495.041 608.7L494.341 608.7L494.342 703.7L495.042 703.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_22">
            <path
              id="Vector_21"
              d="M474.042 961L478.083 954L470 954L474.042 961ZM474.741 732.7L474.741 732L473.341 732L473.341 732.7L474.041 732.7L474.741 732.7ZM474.042 954.7L474.742 954.7L474.741 732.7L474.041 732.7L473.341 732.7L473.342 954.7L474.042 954.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_23">
            <path
              id="Vector_22"
              d="M455.037 1206.23L462.692 1203.64L456.619 1198.3L455.037 1206.23ZM530.232 1121.65L530.694 1121.13L529.642 1120.2L529.18 1120.73L529.706 1121.19L530.232 1121.65ZM459.194 1201.5L459.72 1201.96L530.232 1121.65L529.706 1121.19L529.18 1120.73L458.668 1201.03L459.194 1201.5Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_24">
            <path
              id="Vector_23"
              d="M649.042 856L653.083 849L645 849L649.042 856ZM649.741 583.7L649.741 583L648.341 583L648.341 583.7L649.041 583.7L649.741 583.7ZM649.042 849.7L649.742 849.7L649.741 583.7L649.041 583.7L648.341 583.7L648.342 849.7L649.042 849.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_25">
            <path
              id="Vector_24"
              d="M647.042 1045L651.083 1038L643 1038L647.042 1045ZM647.741 882.7L647.741 882L646.341 882L646.341 882.7L647.041 882.7L647.741 882.7ZM647.042 1038.7L647.742 1038.7L647.741 882.7L647.041 882.7L646.341 882.7L646.342 1038.7L647.042 1038.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_cyp19a1-e2">
            <path
              id="Vector_cyp19a1-e2"
              d="M732.042 1087L736.083 1080L728 1080L732.042 1087ZM732.742 922.7L732.742 922L731.342 922L731.342 922.7L732.042 922.7L732.742 922.7ZM732.042 1106.7L732.742 1106.7L732.742 922.7L732.042 922.7L731.342 922.7L731.342 1106.7L732.042 1106.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_26">
            <path
              id="Vector_25"
              d="M227.042 966.106L231.083 959.106L223 959.106L227.042 966.106ZM227.742 898.806L227.742 898.106L226.342 898.106L226.342 898.806L227.042 898.806L227.742 898.806ZM227.042 959.806L227.742 959.806L227.742 898.806L227.042 898.806L226.342 898.806L226.342 959.806L227.042 959.806Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_27">
            <path
              id="Vector_26"
              d="M353.042 966L357.083 959L349 959L353.042 966ZM353.742 922.7L353.742 922L352.342 922L352.342 922.7L353.042 922.7L353.742 922.7ZM353.042 959.7L353.742 959.7L353.742 922.7L353.042 922.7L352.342 922.7L352.342 959.7L353.042 959.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_28">
            <path
              id="Vector_27"
              d="M85.0415 968L89.083 961L81.0001 961L85.0415 968ZM85.7415 904.7L85.7415 904L84.3415 904L84.3415 904.7L85.0415 904.7L85.7415 904.7ZM85.0415 961.7L85.7415 961.7L85.7415 904.7L85.0415 904.7L84.3415 904.7L84.3415 961.7L85.0415 961.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_29">
            <path
              id="Vector_28"
              d="M85.0415 1120L89.083 1113L81.0001 1113L85.0415 1120ZM85.7415 970.7L85.7415 970L84.3415 970L84.3415 970.7L85.0415 970.7L85.7415 970.7ZM85.0415 1113.7L85.7415 1113.7L85.7415 970.7L85.0415 970.7L84.3415 970.7L84.3415 1113.7L85.0415 1113.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_30">
            <path
              id="Vector_29"
              d="M156.042 1292L160.083 1285L152 1285L156.042 1292ZM156.741 1179.7L156.741 1179L155.341 1179L155.341 1179.7L156.041 1179.7L156.741 1179.7ZM156.042 1285.7L156.742 1285.7L156.741 1179.7L156.041 1179.7L155.341 1179.7L155.342 1285.7L156.042 1285.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_31">
            <path
              id="Vector_30"
              d="M308.042 1292L312.083 1285L304 1285L308.042 1292ZM308.741 1179.7L308.741 1179L307.341 1179L307.341 1179.7L308.041 1179.7L308.741 1179.7ZM308.042 1285.7L308.742 1285.7L308.741 1179.7L308.041 1179.7L307.341 1179.7L307.342 1285.7L308.042 1285.7Z"
              fill="#1A1A1A"
            />
          </g>
          <path id="Vector 320" d="M156 1178H422V927H364.174" stroke="#1A1A1A" strokeWidth={1.4} />
          <g id="lines_32">
            <path
              id="Vector_31"
              d="M230.042 1120L234.083 1113L226 1113L230.042 1120ZM230.741 970.7L230.741 970L229.341 970L229.341 970.7L230.041 970.7L230.741 970.7ZM230.042 1113.7L230.742 1113.7L230.741 970.7L230.041 970.7L229.341 970.7L229.342 1113.7L230.042 1113.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_33">
            <path
              id="Vector_32"
              d="M357.042 1120L361.083 1113L353 1113L357.042 1120ZM357.741 970.7L357.741 970L356.341 970L356.341 970.7L357.041 970.7L357.741 970.7ZM357.042 1113.7L357.742 1113.7L357.741 970.7L357.041 970.7L356.341 970.7L356.342 1113.7L357.042 1113.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_34">
            <path
              id="Vector_33"
              d="M544.042 1180L548.083 1173L540 1173L544.042 1180ZM544.742 1108.7L544.742 1108L543.342 1108L543.342 1108.7L544.042 1108.7L544.742 1108.7ZM544.042 1173.7L544.742 1173.7L544.742 1108.7L544.042 1108.7L543.342 1108.7L543.342 1173.7L544.042 1173.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect x={397.5} y={1472.5} width={446} height={47} fill="white" />
            <rect
              x={397.5}
              y={1472.5}
              width={446}
              height={47}
              stroke="#17224D"
              strokeDasharray="2 2"
            />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={549.262} y={1500.09}>
                Detoxification/Elimination
              </tspan>
            </text>
          </g>
          <g id="lines_35">
            <path
              id="Vector_34"
              d="M732.042 1184L736.083 1177L728 1177L732.042 1184ZM732.742 1107.7L732.742 1107L731.342 1107L731.342 1107.7L732.042 1107.7L732.742 1107.7ZM732.042 1177.7L732.742 1177.7L732.742 1107.7L732.042 1107.7L731.342 1107.7L731.342 1177.7L732.042 1177.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_36">
            <path
              id="Vector_35"
              d="M557.042 1458L561.083 1451L553 1451L557.042 1458ZM557.741 1285.7L557.741 1285L556.341 1285L556.341 1285.7L557.041 1285.7L557.741 1285.7ZM557.042 1451.7L557.742 1451.7L557.741 1285.7L557.041 1285.7L556.341 1285.7L556.342 1451.7L557.042 1451.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_37">
            <path
              id="Vector_36"
              d="M700.042 1458L704.083 1451L696 1451L700.042 1458ZM700.741 1256.7L700.741 1256L699.341 1256L699.341 1256.7L700.041 1256.7L700.741 1256.7ZM700.042 1451.7L700.742 1451.7L700.741 1256.7L700.041 1256.7L699.341 1256.7L699.342 1451.7L700.042 1451.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_38">
            <path
              id="Vector_37"
              d="M699.042 1246L703.083 1239L695 1239L699.042 1246ZM699.742 1225.7L699.742 1225L698.342 1225L698.342 1225.7L699.042 1225.7L699.742 1225.7ZM699.042 1239.7L699.742 1239.7L699.742 1225.7L699.042 1225.7L698.342 1225.7L698.342 1239.7L699.042 1239.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_39">
            <path
              id="Vector_38"
              d="M554.042 1246L558.083 1239L550 1239L554.042 1246ZM554.742 1225.7L554.742 1225L553.342 1225L553.342 1225.7L554.042 1225.7L554.742 1225.7ZM554.042 1239.7L554.742 1239.7L554.742 1225.7L554.042 1225.7L553.342 1225.7L553.342 1239.7L554.042 1239.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_40">
            <path
              id="Vector_39"
              d="M798.042 1458L802.083 1451L794 1451L798.042 1458ZM798.741 1367.7L798.741 1367L797.341 1367L797.341 1367.7L798.041 1367.7L798.741 1367.7ZM798.042 1451.7L798.742 1451.7L798.741 1367.7L798.041 1367.7L797.341 1367.7L797.342 1451.7L798.042 1451.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_41">
            <path
              id="Vector_40"
              d="M791.067 1341.41L788.658 1333.69L783.18 1339.64L791.067 1341.41ZM729.728 1283.93L729.213 1283.46L728.264 1284.49L728.779 1284.96L729.254 1284.45L729.728 1283.93ZM786.434 1337.14L786.908 1336.63L729.728 1283.93L729.254 1284.45L728.779 1284.96L785.959 1337.66L786.434 1337.14Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_42">
            <path
              id="Vector_41"
              d="M441.042 1269L445.083 1262L437 1262L441.042 1269ZM441.742 1234.7L441.742 1234L440.342 1234L440.342 1234.7L441.042 1234.7L441.742 1234.7ZM441.042 1262.7L441.742 1262.7L441.742 1234.7L441.042 1234.7L440.342 1234.7L440.342 1262.7L441.042 1262.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_43">
            <path
              id="Vector_42"
              d="M441.042 1353L445.083 1346L437 1346L441.042 1353ZM441.742 1293.7L441.742 1293L440.342 1293L440.342 1293.7L441.042 1293.7L441.742 1293.7ZM441.042 1346.7L441.742 1346.7L441.742 1293.7L441.042 1293.7L440.342 1293.7L440.342 1346.7L441.042 1346.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_44">
            <path
              id="Vector_43"
              d="M441.042 1458L445.083 1451L437 1451L441.042 1458ZM441.741 1358.7L441.741 1358L440.341 1358L440.341 1358.7L441.041 1358.7L441.741 1358.7ZM441.042 1451.7L441.742 1451.7L441.741 1358.7L441.041 1358.7L440.341 1358.7L440.342 1451.7L441.042 1451.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_45">
            <path
              id="Vector_44"
              d="M351.466 905.425L351.43 897.342L344.448 901.415L351.466 905.425ZM294.448 806.288L294.096 805.684L292.886 806.389L293.239 806.994L293.844 806.641L294.448 806.288ZM348.292 899.983L348.896 899.631L294.448 806.288L293.844 806.641L293.239 806.994L347.687 900.336L348.292 899.983Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_46">
            <path
              id="Vector_45"
              d="M534 857.677L537.135 850.227L529.116 851.237L534 857.677ZM520.011 741.017L519.924 740.322L518.535 740.497L518.622 741.192L519.317 741.104L520.011 741.017ZM533.213 851.427L533.908 851.339L520.011 741.017L519.317 741.104L518.622 741.192L532.519 851.514L533.213 851.427Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_47">
            <path
              id="Vector_46"
              d="M471.8 573.651L464.209 570.874L470.409 565.688L471.8 573.651ZM429.012 523.579L428.563 523.042L429.637 522.144L430.086 522.681L429.549 523.13L429.012 523.579ZM467.758 568.818L467.221 569.267L429.012 523.579L429.549 523.13L430.086 522.681L468.295 568.369L467.758 568.818Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_48">
            <path
              id="Vector_47"
              d="M551.91 432.677L544.319 429.9L550.52 424.714L551.91 432.677ZM484.012 352.579L483.563 352.042L484.637 351.144L485.086 351.681L484.549 352.13L484.012 352.579ZM547.869 427.844L547.332 428.293L484.012 352.579L484.549 352.13L485.086 351.681L548.406 427.395L547.869 427.844Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_49">
            <path
              id="Vector_48"
              d="M354.884 540.455L349.057 534.854L356.821 532.607L354.884 540.455ZM327.404 447.99L327.21 447.318L328.555 446.928L328.749 447.601L328.077 447.795L327.404 447.99ZM353.133 534.403L352.461 534.597L327.404 447.99L328.077 447.795L328.749 447.601L353.806 534.208L353.133 534.403Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_50">
            <path
              id="Vector_49"
              d="M403.846 476.687L395.857 475.461L400.913 469.155L403.846 476.687ZM359.636 442.138L359.09 441.7L359.966 440.607L360.512 441.045L360.074 441.591L359.636 442.138ZM398.931 472.746L398.493 473.292L359.636 442.138L360.074 441.591L360.512 441.045L399.369 472.2L398.931 472.746Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_51">
            <path
              id="Vector_50"
              d="M196.042 647L200.083 640L192 640L196.042 647ZM196.742 564.7L196.742 564L195.342 564L195.342 564.7L196.042 564.7L196.742 564.7ZM196.042 640.7L196.742 640.7L196.742 564.7L196.042 564.7L195.342 564.7L195.342 640.7L196.042 640.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_52">
            <path
              id="Vector_51"
              d="M356.042 595L360.083 588L352 588L356.042 595ZM356.742 570.7L356.742 570L355.342 570L355.342 570.7L356.042 570.7L356.742 570.7ZM356.042 588.7L356.742 588.7L356.742 570.7L356.042 570.7L355.342 570.7L355.342 588.7L356.042 588.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_53">
            <path
              id="Vector_52"
              d="M646.042 551L650.083 544L642 544L646.042 551ZM646.741 460.7L646.741 460L645.341 460L645.341 460.7L646.041 460.7L646.741 460.7ZM646.042 544.7L646.742 544.7L646.741 460.7L646.041 460.7L645.341 460.7L645.342 544.7L646.042 544.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_54">
            <path
              id="Vector_53"
              d="M196.042 725L200.083 718L192 718L196.042 725ZM196.742 676.7L196.742 676L195.342 676L195.342 676.7L196.042 676.7L196.742 676.7ZM196.042 718.7L196.742 718.7L196.742 676.7L196.042 676.7L195.342 676.7L195.342 718.7L196.042 718.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles_2">
            <rect width={77} height={20} transform="translate(416 333)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={416.238} y={347.086}>
                Pregnenolone
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={137} height={20} transform="translate(125 543)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={125.314} y={557.086}>
                5α-Dihydroprogesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={137} height={20} transform="translate(292 544)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={292.396} y={558.086}>
                5β-Dihydroprogesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={110} height={20} transform="translate(432 578)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={432.074} y={592.086}>
                17-OH Progesterone
              </tspan>
            </text>
          </g>
          <g id="lines_56">
            <path
              id="Vector_56"
              d="M775 561.042L768 557L768 565.083L775 561.042ZM673.7 560.342L673 560.342L673 561.742L673.7 561.742L673.7 561.042L673.7 560.342ZM768.7 561.042L768.7 560.342L673.7 560.342L673.7 561.042L673.7 561.742L768.7 561.742L768.7 561.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_57">
            <path
              id="Vector_57"
              d="M774.3 574.742L775 574.742L775 573.342L774.3 573.342L774.3 574.042L774.3 574.742ZM673 574.042L680 578.083L680 570L673 574.042ZM774.3 574.042L774.3 573.342L679.3 573.342L679.3 574.042L679.3 574.742L774.3 574.742L774.3 574.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles_6">
            <rect width={31} height={20} transform="translate(634 559)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={634.043} y={573.086}>
                DHEA
              </tspan>
            </text>
          </g>
          <g id="Report titles_62">
            <rect width={44} height={20} transform="translate(783 559)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_62"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={783.238} y={573.086}>
                DHEA-S
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={95} height={20} transform="translate(448 711)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={448.396} y={725.086}>
                Androstenedione
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={95} height={20} transform="translate(486 861)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={486.396} y={875.086}>
                Androstanedione
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={91} height={36} transform="translate(601 939)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={623.619} y={953.086}>
                3α-diols{" "}
              </tspan>
              <tspan x={601.301} y={969.086}>
                (Androstanediol)
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={130} height={36} transform="translate(582 1046)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
              textAnchor="middle"
            >
              <tspan x={647.042} y={1060.09}>
                Detoxification
              </tspan>
              <tspan x={647.042} y={1076.09}>
                (glucuronidation)
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={24} height={20} transform="translate(636 861)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={636.404} y={875.086}>
                DHT
              </tspan>
            </text>
          </g>
          <path
            id="Vector 323"
            d="M731.722 819V818.3H731.476L731.284 818.453L731.722 819ZM897 819H897.7V818.3H897V819ZM897 846L901.041 839H892.959L897 846ZM668 870L668.437 870.547L669.499 869.697L669.062 869.15L668.625 868.603L667.563 869.453L668 870ZM671.186 867.45L671.623 867.997L673.748 866.297L673.31 865.75L672.873 865.203L670.749 866.903L671.186 867.45ZM675.434 864.05L675.872 864.597L677.996 862.897L677.558 862.35L677.121 861.803L674.997 863.503L675.434 864.05ZM679.682 860.65L680.12 861.197L682.244 859.497L681.806 858.95L681.369 858.403L679.245 860.103L679.682 860.65ZM683.93 857.25L684.368 857.797L686.492 856.097L686.054 855.55L685.617 855.003L683.493 856.703L683.93 857.25ZM688.179 853.85L688.616 854.397L690.74 852.697L690.303 852.15L689.865 851.603L687.741 853.303L688.179 853.85ZM692.427 850.45L692.864 850.997L694.988 849.297L694.551 848.75L694.113 848.203L691.989 849.903L692.427 850.45ZM696.675 847.05L697.112 847.597L699.236 845.897L698.799 845.35L698.361 844.803L696.237 846.503L696.675 847.05ZM700.923 843.65L701.36 844.197L703.484 842.497L703.047 841.95L702.61 841.403L700.485 843.103L700.923 843.65ZM705.171 840.25L705.608 840.797L707.732 839.097L707.295 838.55L706.858 838.003L704.734 839.703L705.171 840.25ZM709.419 836.85L709.857 837.397L711.981 835.697L711.543 835.15L711.106 834.603L708.982 836.303L709.419 836.85ZM713.667 833.45L714.105 833.997L716.229 832.297L715.791 831.75L715.354 831.203L713.23 832.903L713.667 833.45ZM717.915 830.05L718.353 830.597L720.477 828.897L720.039 828.35L719.602 827.803L717.478 829.503L717.915 830.05ZM722.163 826.65L722.601 827.197L724.725 825.497L724.288 824.95L723.85 824.403L721.726 826.103L722.163 826.65ZM726.412 823.25L726.849 823.797L728.973 822.097L728.536 821.55L728.098 821.003L725.974 822.703L726.412 823.25ZM730.66 819.85L731.097 820.397L732.159 819.547L731.722 819L731.284 818.453L730.222 819.303L730.66 819.85ZM731.722 819V819.7H733.099V819V818.3H731.722V819ZM735.854 819V819.7H738.608V819V818.3H735.854V819ZM741.363 819V819.7H744.118V819V818.3H741.363V819ZM746.872 819V819.7H749.627V819V818.3H746.872V819ZM752.382 819V819.7H755.136V819V818.3H752.382V819ZM757.891 819V819.7H760.645V819V818.3H757.891V819ZM763.4 819V819.7H766.155V819V818.3H763.4V819ZM768.909 819V819.7H771.664V819V818.3H768.909V819ZM774.419 819V819.7H777.173V819V818.3H774.419V819ZM779.928 819V819.7H782.683V819V818.3H779.928V819ZM785.437 819V819.7H788.192V819V818.3H785.437V819ZM790.946 819V819.7H793.701V819V818.3H790.946V819ZM796.456 819V819.7H799.21V819V818.3H796.456V819ZM801.965 819V819.7H804.72V819V818.3H801.965V819ZM807.474 819V819.7H810.229V819V818.3H807.474V819ZM812.984 819V819.7H815.738V819V818.3H812.984V819ZM818.493 819V819.7H821.247V819V818.3H818.493V819ZM824.002 819V819.7H826.757V819V818.3H824.002V819ZM829.511 819V819.7H832.266V819V818.3H829.511V819ZM835.021 819V819.7H837.775V819V818.3H835.021V819ZM840.53 819V819.7H843.285V819V818.3H840.53V819ZM846.039 819V819.7H848.794V819V818.3H846.039V819ZM851.549 819V819.7H854.303V819V818.3H851.549V819ZM857.058 819V819.7H859.812V819V818.3H857.058V819ZM862.567 819V819.7H865.322V819V818.3H862.567V819ZM868.076 819V819.7H870.831V819V818.3H868.076V819ZM873.586 819V819.7H876.34V819V818.3H873.586V819ZM879.095 819V819.7H881.85V819V818.3H879.095V819ZM884.604 819V819.7H887.359V819V818.3H884.604V819ZM890.113 819V819.7H892.868V819V818.3H890.113V819ZM895.623 819V819.7H897V819V818.3H895.623V819ZM897 819H896.3V820.35H897H897.7V819H897ZM897 823.05H896.3V825.75H897H897.7V823.05H897ZM897 828.45H896.3V831.15H897H897.7V828.45H897ZM897 833.85H896.3V836.55H897H897.7V833.85H897ZM897 839.25H896.3V841.95H897H897.7V839.25H897Z"
            fill="#818181"
          />
          <path
            id="Vector 324"
            d="M909 730H909.7V729.3H909V730ZM909 847L913.041 840H904.959L909 847ZM714 730V730.7H715.393V730V729.3H714V730ZM718.179 730V730.7H720.964V730V729.3H718.179V730ZM723.75 730V730.7H726.536V730V729.3H723.75V730ZM729.321 730V730.7H732.107V730V729.3H729.321V730ZM734.893 730V730.7H737.679V730V729.3H734.893V730ZM740.464 730V730.7H743.25V730V729.3H740.464V730ZM746.036 730V730.7H748.821V730V729.3H746.036V730ZM751.607 730V730.7H754.393V730V729.3H751.607V730ZM757.179 730V730.7H759.964V730V729.3H757.179V730ZM762.75 730V730.7H765.536V730V729.3H762.75V730ZM768.321 730V730.7H771.107V730V729.3H768.321V730ZM773.893 730V730.7H776.679V730V729.3H773.893V730ZM779.464 730V730.7H782.25V730V729.3H779.464V730ZM785.036 730V730.7H787.821V730V729.3H785.036V730ZM790.607 730V730.7H793.393V730V729.3H790.607V730ZM796.179 730V730.7H798.964V730V729.3H796.179V730ZM801.75 730V730.7H804.536V730V729.3H801.75V730ZM807.321 730V730.7H810.107V730V729.3H807.321V730ZM812.893 730V730.7H815.679V730V729.3H812.893V730ZM818.464 730V730.7H821.25V730V729.3H818.464V730ZM824.036 730V730.7H826.821V730V729.3H824.036V730ZM829.607 730V730.7H832.393V730V729.3H829.607V730ZM835.179 730V730.7H837.964V730V729.3H835.179V730ZM840.75 730V730.7H843.536V730V729.3H840.75V730ZM846.321 730V730.7H849.107V730V729.3H846.321V730ZM851.893 730V730.7H854.679V730V729.3H851.893V730ZM857.464 730V730.7H860.25V730V729.3H857.464V730ZM863.036 730V730.7H865.821V730V729.3H863.036V730ZM868.607 730V730.7H871.393V730V729.3H868.607V730ZM874.179 730V730.7H876.964V730V729.3H874.179V730ZM879.75 730V730.7H882.536V730V729.3H879.75V730ZM885.322 730V730.7H888.107V730V729.3H885.322V730ZM890.893 730V730.7H893.679V730V729.3H890.893V730ZM896.464 730V730.7H899.25V730V729.3H896.464V730ZM902.036 730V730.7H904.822V730V729.3H902.036V730ZM907.607 730V730.7H909V730V729.3H907.607V730ZM909 730H908.3V731.393H909H909.7V730H909ZM909 734.179H908.3V736.964H909H909.7V734.179H909ZM909 739.75H908.3V742.536H909H909.7V739.75H909ZM909 745.321H908.3V748.107H909H909.7V745.321H909ZM909 750.893H908.3V753.679H909H909.7V750.893H909ZM909 756.464H908.3V759.25H909H909.7V756.464H909ZM909 762.036H908.3V764.821H909H909.7V762.036H909ZM909 767.607H908.3V770.393H909H909.7V767.607H909ZM909 773.179H908.3V775.964H909H909.7V773.179H909ZM909 778.75H908.3V781.536H909H909.7V778.75H909ZM909 784.321H908.3V787.107H909H909.7V784.321H909ZM909 789.893H908.3V792.679H909H909.7V789.893H909ZM909 795.464H908.3V798.25H909H909.7V795.464H909ZM909 801.036H908.3V803.821H909H909.7V801.036H909ZM909 806.607H908.3V809.393H909H909.7V806.607H909ZM909 812.179H908.3V814.964H909H909.7V812.179H909ZM909 817.75H908.3V820.536H909H909.7V817.75H909ZM909 823.321H908.3V826.107H909H909.7V823.321H909ZM909 828.893H908.3V831.679H909H909.7V828.893H909ZM909 834.464H908.3V837.25H909H909.7V834.464H909ZM909 840.036H908.3V842.821H909H909.7V840.036H909Z"
            fill="#818181"
          />
          <g id="Report titles_12">
            <rect width={32} height={20} transform="translate(807 847)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={807.092} y={861.086}>
                SHBG
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <rect width={25} height={20} transform="translate(862 1117)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={862.131} y={1131.09}>
                ESR1
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={27} height={20} transform="translate(907 1117)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={907.047} y={1131.09}>
                ESR2
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <rect width={16} height={20} transform="translate(893 846)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_15"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={893.477} y={860.086}>
                AR
              </tspan>
            </text>
          </g>
          <g id="Report titles_16">
            <rect width={70} height={20} transform="translate(614 718)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_16"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={614.125} y={732.086}>
                Testosterone
              </tspan>
            </text>
          </g>
          <path
            id="Vector 321"
            d="M714 731H714.7V730.3H714V731ZM714 894L718.041 887H709.959L714 894ZM689 731V731.7H714V731V730.3H689V731ZM714 731H713.3V887.7H714H714.7V731H714Z"
            fill="#1A1A1A"
          />
          <g id="Report titles_17">
            <rect width={84} height={20} transform="translate(608 660)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_17"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={608.463} y={674.086}>
                Androstenediol
              </tspan>
            </text>
          </g>
          <g id="Report titles_18">
            <rect width={98} height={20} transform="translate(146 650)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_18"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={146.016} y={664.086}>
                Allopregnanolone
              </tspan>
            </text>
          </g>
          <g id="Report titles_19">
            <rect width={88} height={20} transform="translate(149 730)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_19"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={149.441} y={744.086}>
                α-Pregnanediol
              </tspan>
            </text>
          </g>
          <g id="Report titles_20">
            <rect width={87} height={20} transform="translate(312 596)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_20"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={312.023} y={610.086}>
                β-Pregnanediol
              </tspan>
            </text>
          </g>
          <g id="Report titles_21">
            <rect width={89} height={20} transform="translate(314 728)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_21"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={314.35} y={742.086}>
                11-deoxycortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_22">
            <rect width={113} height={20} transform="translate(29 965)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_22"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={29.1328} y={979.086}>
                5α-dihydrocortisone
              </tspan>
            </text>
          </g>
          <g id="Report titles_23">
            <rect width={93} height={20} transform="translate(40 1122)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_23"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={40.1641} y={1136.09}>
                Urinary excretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_24">
            <rect width={93} height={20} transform="translate(184 1122)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_24"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={184.164} y={1136.09}>
                Urinary excretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_25">
            <rect width={133} height={36} transform="translate(90 1298)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_25"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={90.4414} y={1312.09}>
                Modulates the HPA axis{" "}
              </tspan>
              <tspan x={91.0391} y={1328.09}>
                (stress response system)
              </tspan>
            </text>
          </g>
          <g id="Report titles_26">
            <rect width={111} height={36} transform="translate(769 906)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_26"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={771.771} y={919.405}>
                Biologically inactivates{" "}
              </tspan>
              <tspan x={775.374} y={935.405}>
                hormones bound to it
              </tspan>
            </text>
          </g>
          <g id="Report titles_27">
            <rect width={110} height={20} transform="translate(729 790)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_27"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={734.376} y={803.405}>
                Binds to (high affinity)
              </tspan>
            </text>
          </g>
          <g id="Report titles_28">
            <rect width={170} height={36} transform="translate(773 1037)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_28"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={773} y={1050.4}>
                Binds to (high affinity);{" "}
              </tspan>
              <tspan x={773} y={1066.4}>
                E1 and E3 have lower affinity
              </tspan>
            </text>
          </g>
          <g id="Report titles_29">
            <rect width={132} height={20} transform="translate(729 704)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_29"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={732.622} y={717.405}>
                Binds to (moderate affinity)
              </tspan>
            </text>
          </g>
          <g id="Report titles_30">
            <rect width={128} height={68} transform="translate(839 950)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_30"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={855.358} y={963.405}>
                Bound hormones are{" "}
              </tspan>
              <tspan x={850.886} y={979.405}>
                transported to nucleus{" "}
              </tspan>
              <tspan x={844.318} y={995.405}>
                where they bind DNA and{" "}
              </tspan>
              <tspan x={852.302} y={1011.4}>
                regulate gene activity
              </tspan>
            </text>
          </g>
          <g id="Report titles_31">
            <rect width={128} height={68} transform="translate(838 1189)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_31"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={854.358} y={1202.4}>
                Bound hormones are{" "}
              </tspan>
              <tspan x={849.886} y={1218.4}>
                transported to nucleus{" "}
              </tspan>
              <tspan x={843.318} y={1234.4}>
                where they bind DNA and{" "}
              </tspan>
              <tspan x={851.302} y={1250.4}>
                regulate gene activity
              </tspan>
            </text>
          </g>
          <g id="Report titles_32">
            <rect width={101} height={68} transform="translate(257 1298)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_32"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={260.057} y={1312.09}>
                Regulation of the{" "}
              </tspan>
              <tspan x={261.668} y={1328.09}>
                bioavailability of{" "}
              </tspan>
              <tspan x={268.834} y={1344.09}>
                active cortisol{" "}
              </tspan>
              <tspan x={257.004} y={1360.09}>
                (release to tissues)
              </tspan>
            </text>
          </g>
          <g id="Report titles_33">
            <rect width={93} height={20} transform="translate(309 1122)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_33"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={309.164} y={1136.09}>
                Urinary excretion
              </tspan>
            </text>
          </g>
          <g id="Report titles_34">
            <rect width={110} height={20} transform="translate(30 1079)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_34"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={30} y={1092.4}>
                Glucuronidase enzymes
              </tspan>
            </text>
          </g>
          <g id="Report titles_35">
            <rect width={101} height={20} transform="translate(179 1080)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_35"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={179.268} y={1093.4}>
                Undergoes sulphation
              </tspan>
            </text>
          </g>
          <g id="Report titles_36">
            <rect width={115} height={36} transform="translate(21 1252)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_36"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={21.3516} y={1265.4}>
                Regulates glucocorticoid{" "}
              </tspan>
              <tspan x={27.3672} y={1281.4}>
                receptor (GR) sensitivity
              </tspan>
            </text>
          </g>
          <g id="Report titles_37">
            <rect width={79} height={20} transform="translate(221 1256)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_37"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={221.289} y={1269.4}>
                Transport protein
              </tspan>
            </text>
          </g>
          <g id="Report titles_38">
            <rect width={110} height={20} transform="translate(304 1080)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_38"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={304.898} y={1093.4}>
                Glucuronidase enzymes
              </tspan>
            </text>
          </g>
          <g id="Report titles_39">
            <rect width={21} height={20} transform="translate(76 1046)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_39"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={76.0293} y={1060.09}>
                THE
              </tspan>
            </text>
          </g>
          <g id="Report titles_40">
            <rect width={41} height={20} transform="translate(212 1047)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_40"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={212.279} y={1061.09}>
                5α-THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_41">
            <rect width={41} height={20} transform="translate(337 1045)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_41"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={337.361} y={1059.09}>
                5β-THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_42">
            <rect width={11} height={20} transform="translate(540 1087)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_42"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={540.162} y={1101.09}>
                E1
              </tspan>
            </text>
          </g>
          <g id="Report titles_43">
            <rect width={60} height={20} transform="translate(411 1272)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_43"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={411.475} y={1286.09}>
                16a-OH-E1
              </tspan>
            </text>
          </g>
          <g id="Report titles_44">
            <rect width={48} height={20} transform="translate(534 1247)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_44"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={534.475} y={1261.09}>
                2-OH-E1
              </tspan>
            </text>
          </g>
          <g id="Report titles_45">
            <rect width={48} height={20} transform="translate(675 1247)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_45"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={675.158} y={1261.09}>
                4-OH-E1
              </tspan>
            </text>
          </g>
          <g id="Report titles_46">
            <rect width={52} height={20} transform="translate(532 1337)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_46"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={532.277} y={1351.09}>
                2-MeOE2
              </tspan>
            </text>
          </g>
          <g id="Report titles_47">
            <rect width={51} height={20} transform="translate(674 1341)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_47"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={674.469} y={1355.09}>
                4-MeOE1
              </tspan>
            </text>
          </g>
          <g id="Report titles_48">
            <rect width={53} height={20} transform="translate(772 1342)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_48"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={772.426} y={1356.09}>
                Quinones
              </tspan>
            </text>
          </g>
          <g id="Report titles_49">
            <rect width={52} height={20} transform="translate(414 1337)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_49"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={414.277} y={1351.09}>
                2-MeOE2
              </tspan>
            </text>
          </g>
          <g id="Report titles_50">
            <rect width={50} height={20} transform="translate(533 1263)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_50"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={533.467} y={1277.09}>
                2-OH-E2
              </tspan>
            </text>
          </g>
          <g id="Report titles_51">
            <rect width={50} height={20} transform="translate(674 1264)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_51"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={674.15} y={1278.09}>
                4-OH-E2
              </tspan>
            </text>
          </g>
          <g id="Report titles_52">
            <rect width={52} height={20} transform="translate(532 1358)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_52"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={532.277} y={1372.09}>
                2-MeOE2
              </tspan>
            </text>
          </g>
          <g id="Report titles_53">
            <rect width={53} height={20} transform="translate(675 1358)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_53"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={675.461} y={1372.09}>
                4-MeOE2
              </tspan>
            </text>
          </g>
          <g id="Report titles_54">
            <rect width={13} height={20} transform="translate(726 1087)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_54"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={726.154} y={1101.09}>
                E2
              </tspan>
            </text>
          </g>
          <g id="Report titles_55">
            <rect width={102} height={20} transform="translate(175 965)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_55"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={175.199} y={979.086}>
                5α-dihydrocortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_56">
            <rect width={103} height={20} transform="translate(306 963)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_56"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={306.271} y={977.086}>
                5β-Dihydrocortisol
              </tspan>
            </text>
          </g>
          <g id="Report titles_57">
            <rect width={43} height={36} transform="translate(210 862)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_57"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={210.289} y={876.086}>
                Cortisol{" "}
              </tspan>
              <tspan x={211.01} y={892.086}>
                (active)
              </tspan>
            </text>
          </g>
          <g id="Report titles_58">
            <rect width={51} height={36} transform="translate(61 864)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_58"
              fill="#17C6E9"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={59.2891} y={878.086}>
                Cortisone{" "}
              </tspan>
              <tspan x={61.3047} y={894.086}>
                (inactive)
              </tspan>
            </text>
          </g>
          <g id="Report titles_59">
            <rect width={75} height={20} transform="translate(275 428)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_59"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={275.445} y={442.098}>
                Progesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_60">
            <rect width={120} height={20} transform="translate(545 436)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_60"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={548.404} y={450.086}>
                17-OH Pregnenolone
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_61">
              <rect width={83} height={28} transform="translate(412 230)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_61"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={412.383} y={249.44}>
                  Cholesterol
                </tspan>
              </text>
            </g>
            <g id="lines_55">
              <path
                id="Vector_54"
                d="M454.158 258.7L454.158 258L452.758 258L452.758 258.7L453.458 258.7L454.158 258.7ZM453.458 333L457.5 326L449.417 326L453.458 333ZM453.458 258.7L452.758 258.7L452.758 326.7L453.458 326.7L454.158 326.7L454.158 258.7L453.458 258.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="gene-CYP11A1" {...geneGroupProps("CYP11A1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M414 280C414 277.791 415.791 276 418 276H493C495.209 276 497 277.791 497 280V296C497 298.209 495.209 300 493 300H418C415.791 300 414 298.209 414 296V280Z"
                fill={cyp11a1.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={430.487} y={292.767}>
                  CYP11A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp11a1"
              groupId="gene-snps"
              genePalette={cyp11a1}
              startX={422}
              startY={302}
              snpCount={getGeneSnpCount("CYP11A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C" {...geneGroupProps("AKR1C", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M154 588C154 585.791 155.791 584 158 584H230C232.209 584 234 585.791 234 588V604C234 606.209 232.209 608 230 608H158C155.791 608 154 606.209 154 604V588Z"
                fill={akr1c.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={173.479} y={600.767}>
                  AKR1C
                </tspan>
              </text>
              <path
                id="*_3"
                d="M243.875 581.754V583.477L241.199 583.384L242.728 585.692L241.228 586.615L239.875 584.123L238.522 586.615L237.022 585.692L238.551 583.384L235.875 583.477L235.875 581.754L238.551 581.846L237.022 579.538L238.522 578.615L239.875 581.108L241.228 578.615L242.728 579.538L241.199 581.846L243.875 581.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c"
              groupId="gene-snps_2"
              genePalette={akr1c}
              startX={162}
              startY={610}
              snpCount={getGeneSnpCount("AKR1C", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C1" {...geneGroupProps("AKR1C1", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M41 922C41 919.791 42.7909 918 45 918H117C119.209 918 121 919.791 121 922V938C121 940.209 119.209 942 117 942H45C42.7909 942 41 940.209 41 938V922Z"
                fill={akr1c1.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={57.9834} y={934.767}>
                  AKR1C1
                </tspan>
              </text>
              <path
                id="*_4"
                d="M130.875 915.754V917.477L128.199 917.384L129.728 919.692L128.228 920.615L126.875 918.123L125.522 920.615L124.022 919.692L125.551 917.384L122.875 917.477L122.875 915.754L125.551 915.846L124.022 913.538L125.522 912.615L126.875 915.108L128.228 912.615L129.728 913.538L128.199 915.846L130.875 915.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c1"
              groupId="gene-snps_3"
              genePalette={akr1c1}
              startX={49}
              startY={944}
              snpCount={getGeneSnpCount("AKR1C1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M183 919C183 916.791 184.791 915 187 915H259C261.209 915 263 916.791 263 919V935C263 937.209 261.209 939 259 939H187C184.791 939 183 937.209 183 935V919Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={199.409} y={931.767}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1"
              groupId="gene-snps_4"
              genePalette={srd5a1}
              startX={191}
              startY={941}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1D1" {...geneGroupProps("AKR1D1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M311 917C311 914.791 312.791 913 315 913H387C389.209 913 391 914.791 391 917V933C391 935.209 389.209 937 387 937H315C312.791 937 311 935.209 311 933V917Z"
                fill={akr1d1.lozengeFill}
              />
              <text
                id="gene-label_9"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={328.202} y={929.767}>
                  AKR1D1
                </tspan>
              </text>
              <path
                id="*_5"
                d="M400.875 910.754V912.477L398.199 912.384L399.728 914.692L398.228 915.615L396.875 913.123L395.522 915.615L394.022 914.692L395.551 912.384L392.875 912.477L392.875 910.754L395.551 910.846L394.022 908.538L395.522 907.615L396.875 910.108L398.228 907.615L399.728 908.538L398.199 910.846L400.875 910.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1d1"
              groupId="gene-snps_5"
              genePalette={akr1d1}
              startX={319}
              startY={939}
              snpCount={getGeneSnpCount("AKR1D1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C2" {...geneGroupProps("AKR1C2", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M317 1002C317 999.791 318.791 998 321 998H394C396.209 998 398 999.791 398 1002V1018C398 1020.21 396.209 1022 394 1022H321C318.791 1022 317 1020.21 317 1018V1002Z"
                fill={akr1c2.lozengeFill}
              />
              <text
                id="gene-label_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={333.355} y={1014.77}>
                  AKR1C2
                </tspan>
              </text>
              <path
                id="*_6"
                d="M407.875 995.754V997.477L405.199 997.384L406.728 999.692L405.228 1000.62L403.875 998.123L402.522 1000.62L401.022 999.692L402.551 997.384L399.875 997.477L399.875 995.754L402.551 995.846L401.022 993.538L402.522 992.615L403.875 995.108L405.228 992.615L406.728 993.538L405.199 995.846L407.875 995.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c2"
              groupId="gene-snps_6"
              genePalette={akr1c2}
              startX={325}
              startY={1024}
              snpCount={getGeneSnpCount("AKR1C2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C2_2" {...geneGroupProps("AKR1C2", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M189 1002C189 999.791 190.791 998 193 998H266C268.209 998 270 999.791 270 1002V1018C270 1020.21 268.209 1022 266 1022H193C190.791 1022 189 1020.21 189 1018V1002Z"
                fill={akr1c2.lozengeFill}
              />
              <text
                id="gene-label_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={205.355} y={1014.77}>
                  AKR1C2
                </tspan>
              </text>
              <path
                id="*_7"
                d="M279.875 995.754V997.477L277.199 997.384L278.728 999.692L277.228 1000.62L275.875 998.123L274.522 1000.62L273.022 999.692L274.551 997.384L271.875 997.477L271.875 995.754L274.551 995.846L273.022 993.538L274.522 992.615L275.875 995.108L277.228 992.615L278.728 993.538L277.199 995.846L279.875 995.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c2-2"
              groupId="gene-snps_7"
              genePalette={akr1c2}
              startX={197}
              startY={1024}
              snpCount={getGeneSnpCount("AKR1C2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FKBP5" {...geneGroupProps("FKBP5", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M116 1216C116 1213.79 117.791 1212 120 1212H192C194.209 1212 196 1213.79 196 1216V1232C196 1234.21 194.209 1236 192 1236H120C117.791 1236 116 1234.21 116 1232V1216Z"
                fill={fkbp5.lozengeFill}
              />
              <text
                id="gene-label_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={136.012} y={1228.77}>
                  FKBP5
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fkbp5"
              groupId="gene-snps_8"
              genePalette={fkbp5}
              startX={124}
              startY={1238}
              snpCount={getGeneSnpCount("FKBP5", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SERPINA6" {...geneGroupProps("SERPINA6", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M264 1216C264 1213.79 265.791 1212 268 1212H354C356.209 1212 358 1213.79 358 1216V1232C358 1234.21 356.209 1236 354 1236H268C265.791 1236 264 1234.21 264 1232V1216Z"
                fill={serpina6.lozengeFill}
              />
              <text
                id="gene-label_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={280.156} y={1228.77}>
                  SERPINA6
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="serpina6"
              groupId="gene-snps_9"
              genePalette={serpina6}
              startX={272}
              startY={1238}
              snpCount={getGeneSnpCount("SERPINA6", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C2_3" {...geneGroupProps("AKR1C2", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M47 1002C47 999.791 48.7909 998 51 998H124C126.209 998 128 999.791 128 1002V1018C128 1020.21 126.209 1022 124 1022H51C48.7909 1022 47 1020.21 47 1018V1002Z"
                fill={akr1c2.lozengeFill}
              />
              <text
                id="gene-label_14"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={63.3555} y={1014.77}>
                  AKR1C2
                </tspan>
              </text>
              <path
                id="*_8"
                d="M137.875 995.754V997.477L135.199 997.384L136.728 999.692L135.228 1000.62L133.875 998.123L132.522 1000.62L131.022 999.692L132.551 997.384L129.875 997.477L129.875 995.754L132.551 995.846L131.022 993.538L132.522 992.615L133.875 995.108L135.228 992.615L136.728 993.538L135.199 995.846L137.875 995.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c2-3"
              groupId="gene-snps_10"
              genePalette={akr1c2}
              startX={55}
              startY={1024}
              snpCount={getGeneSnpCount("AKR1C2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD3B1" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M319 382C319 379.791 320.791 378 323 378H395C397.209 378 399 379.791 399 382V398C399 400.209 397.209 402 395 402H323C320.791 402 319 400.209 319 398V382Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-label_15"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={335.149} y={394.767}>
                  HSD3B1
                </tspan>
              </text>
              <path
                id="*_9"
                d="M408.875 375.754V377.477L406.199 377.384L407.728 379.692L406.228 380.615L404.875 378.123L403.522 380.615L402.022 379.692L403.551 377.384L400.875 377.477L400.875 375.754L403.551 375.846L402.022 373.538L403.522 372.615L404.875 375.108L406.228 372.615L407.728 373.538L406.199 375.846L408.875 375.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="hsd3b1"
              groupId="gene-snps_11"
              genePalette={hsd3b1}
              startX={327}
              startY={404}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1_2" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_16">
              <path
                d="M214 478C214 475.791 215.791 474 218 474H290C292.209 474 294 475.791 294 478V494C294 496.209 292.209 498 290 498H218C215.791 498 214 496.209 214 494V478Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-label_16"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={230.409} y={490.767}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1-2"
              groupId="gene-snps_12"
              genePalette={srd5a1}
              startX={222}
              startY={500}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_17">
              <path
                d="M374 484C374 481.791 375.791 480 378 480H454C456.209 480 458 481.791 458 484V500C458 502.209 456.209 504 454 504H378C375.791 504 374 502.209 374 500V484Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-label_17"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={390.399} y={496.767}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1"
              groupId="gene-snps_13"
              genePalette={cyp17a1}
              startX={382}
              startY={506}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP21A2" {...geneGroupProps("CYP21A2", onGeneClick)}>
            <g id="gene-lozenge_18">
              <path
                d="M352 654C352 651.791 353.791 650 356 650H436C438.209 650 440 651.791 440 654V670C440 672.209 438.209 674 436 674H356C353.791 674 352 672.209 352 670V654Z"
                fill={cyp21a2.lozengeFill}
              />
              <text
                id="gene-label_18"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={368.314} y={666.767}>
                  CYP21A2
                </tspan>
              </text>
              <path
                id="*_10"
                d="M449.875 647.754V649.477L447.199 649.384L448.728 651.692L447.228 652.615L445.875 650.123L444.522 652.615L443.022 651.692L444.551 649.384L441.875 649.477L441.875 647.754L444.551 647.846L443.022 645.538L444.522 644.615L445.875 647.108L447.228 644.615L448.728 645.538L447.199 647.846L449.875 647.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="cyp21a2"
              groupId="gene-snps_14"
              genePalette={cyp21a2}
              startX={360}
              startY={676}
              snpCount={getGeneSnpCount("CYP21A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP11B1" {...geneGroupProps("CYP11B1", onGeneClick)}>
            <g id="gene-lozenge_19">
              <path
                d="M222 784C222 781.791 223.791 780 226 780H300C302.209 780 304 781.791 304 784V800C304 802.209 302.209 804 300 804H226C223.791 804 222 802.209 222 800V784Z"
                fill={cyp11b1.lozengeFill}
              />
              <text
                id="gene-label_19"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={238.042} y={796.767}>
                  CYP11B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp11b1"
              groupId="gene-snps_15"
              genePalette={cyp11b1}
              startX={230}
              startY={806}
              snpCount={getGeneSnpCount("CYP11B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD11B1" {...geneGroupProps("HSD11B1", onGeneClick)}>
            <g id="gene-lozenge_20">
              <path
                d="M123 836C123 833.791 124.791 832 127 832H202C204.209 832 206 833.791 206 836V852C206 854.209 204.209 856 202 856H127C124.791 856 123 854.209 123 852V836Z"
                fill={hsd11b1.lozengeFill}
              />
              <text
                id="gene-label_20"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={139.337} y={848.767}>
                  HSD11B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="hsd11b1"
              groupId="gene-snps_16"
              genePalette={hsd11b1}
              startX={131}
              startY={858}
              snpCount={getGeneSnpCount("HSD11B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={86.1836} y={821.086}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_55">
                <mask id="path-250-inside-4_18293_224300" fill="white">
                  <path d="M106 792L131 804.121V829.879L106 842L81 829.879V804.121L106 792Z" />
                </mask>
                <path
                  d="M106 792L131 804.121V829.879L106 842L81 829.879V804.121L106 792Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-250-inside-4_18293_224300)"
                />
              </g>
            </g>
          </g>
          <g id="gene-HSD3B1_2" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_21">
              <path
                d="M497 483C497 480.791 498.791 479 501 479H573C575.209 479 577 480.791 577 483V499C577 501.209 575.209 503 573 503H501C498.791 503 497 501.209 497 499V483Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-label_21"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={513.149} y={495.767}>
                  HSD3B1
                </tspan>
              </text>
              <path
                id="*_11"
                d="M586.875 476.754V478.477L584.199 478.384L585.728 480.692L584.228 481.615L582.875 479.123L581.522 481.615L580.022 480.692L581.551 478.384L578.875 478.477L578.875 476.754L581.551 476.846L580.022 474.538L581.522 473.615L582.875 476.108L584.228 473.615L585.728 474.538L584.199 476.846L586.875 476.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="hsd3b1-2"
              groupId="gene-snps_17"
              genePalette={hsd3b1}
              startX={505}
              startY={505}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD3B1_3" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_22">
              <path
                d="M557 617C557 614.791 558.791 613 561 613H633C635.209 613 637 614.791 637 617V633C637 635.209 635.209 637 633 637H561C558.791 637 557 635.209 557 633V617Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-label_22"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={573.149} y={629.767}>
                  HSD3B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="hsd3b1-3"
              groupId="gene-snps_18"
              genePalette={hsd3b1}
              startX={565}
              startY={639}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_2" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_23">
              <path
                d="M457 654C457 651.791 458.791 650 461 650H537C539.209 650 541 651.791 541 654V670C541 672.209 539.209 674 537 674H461C458.791 674 457 672.209 457 670V654Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-label_23"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={473.399} y={666.767}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-2"
              groupId="gene-snps_19"
              genePalette={cyp17a1}
              startX={465}
              startY={676}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1_3" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_24">
              <path
                d="M494 759C494 756.791 495.791 755 498 755H570C572.209 755 574 756.791 574 759V775C574 777.209 572.209 779 570 779H498C495.791 779 494 777.209 494 775V759Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-label_24"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={510.409} y={771.767}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1-3"
              groupId="gene-snps_20"
              genePalette={srd5a1}
              startX={502}
              startY={781}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1_4" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_25">
              <path
                d="M609 759C609 756.791 610.791 755 613 755H685C687.209 755 689 756.791 689 759V775C689 777.209 687.209 779 685 779H613C610.791 779 609 777.209 609 775V759Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-label_25"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={625.409} y={771.767}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1-4"
              groupId="gene-snps_21"
              genePalette={srd5a1}
              startX={617}
              startY={781}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SHBG" {...geneGroupProps("SHBG", onGeneClick)}>
            <g id="gene-lozenge_26">
              <path
                d="M721 848C721 845.791 722.791 844 725 844H797C799.209 844 801 845.791 801 848V864C801 866.209 799.209 868 797 868H725C722.791 868 721 866.209 721 864V848Z"
                fill={shbg.lozengeFill}
              />
              <text
                id="gene-label_26"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={742.44} y={860.767}>
                  SHBG
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="shbg"
              groupId="gene-snps_22"
              genePalette={shbg}
              startX={729}
              startY={870}
              snpCount={getGeneSnpCount("SHBG", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP19A1" {...geneGroupProps("CYP19A1", onGeneClick)}>
            <g id="gene-lozenge_27">
              <path
                d="M670 902C670 899.791 671.791 898 674 898H751C753.209 898 755 899.791 755 902V918C755 920.209 753.209 922 751 922H674C671.791 922 670 920.209 670 918V902Z"
                fill={cyp19a1.lozengeFill}
              />
              <text
                id="gene-label_27"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={686.496} y={914.767}>
                  CYP19A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp19a1"
              groupId="gene-snps_23"
              genePalette={cyp19a1}
              startX={678}
              startY={924}
              snpCount={getGeneSnpCount("CYP19A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-UGT2B15" {...geneGroupProps("UGT2B15", onGeneClick)}>
            <g id="gene-lozenge_28">
              <path
                d="M603 988C603 985.791 604.791 984 607 984H686C688.209 984 690 985.791 690 988V1004C690 1006.21 688.209 1008 686 1008H607C604.791 1008 603 1006.21 603 1004V988Z"
                fill={ugt2b15.lozengeFill}
              />
              <text
                id="gene-label_28"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={619.006} y={1000.77}>
                  UGT2B15
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ugt2b15"
              groupId="gene-snps_24"
              genePalette={ugt2b15}
              startX={611}
              startY={1010}
              snpCount={getGeneSnpCount("UGT2B15", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD17B1" {...geneGroupProps("HSD17B1", onGeneClick)}>
            <g id="gene-lozenge_29">
              <path
                d="M572 1092C572 1089.79 573.791 1088 576 1088H653C655.209 1088 657 1089.79 657 1092V1108C657 1110.21 655.209 1112 653 1112H576C573.791 1112 572 1110.21 572 1108V1092Z"
                fill={hsd17b1.lozengeFill}
              />
              <text
                id="gene-label_29"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={588.4} y={1104.77}>
                  HSD17B1
                </tspan>
              </text>
            </g>
          </g>
          <g id="gene-CYP1A1" {...geneGroupProps("CYP1A1", onGeneClick)}>
            <g id="gene-lozenge_30">
              <path
                d="M518 1191C518 1188.79 519.791 1187 522 1187H594C596.209 1187 598 1188.79 598 1191V1207C598 1209.21 596.209 1211 594 1211H522C519.791 1211 518 1209.21 518 1207V1191Z"
                fill={cyp1a1.lozengeFill}
              />
              <text
                id="gene-label_30"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={535.482} y={1203.77}>
                  CYP1A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp1a1"
              groupId="gene-snps_25"
              genePalette={cyp1a1}
              startX={526}
              startY={1213}
              snpCount={getGeneSnpCount("CYP1A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP1B1" {...geneGroupProps("CYP1B1", onGeneClick)}>
            <g id="gene-lozenge_31">
              <path
                d="M658 1191C658 1188.79 659.791 1187 662 1187H734C736.209 1187 738 1188.79 738 1191V1207C738 1209.21 736.209 1211 734 1211H662C659.791 1211 658 1209.21 658 1207V1191Z"
                fill={cyp1b1.lozengeFill}
              />
              <text
                id="gene-label_31"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={675.537} y={1203.77}>
                  CYP1B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp1b1"
              groupId="gene-snps_26"
              genePalette={cyp1b1}
              startX={666}
              startY={1213}
              snpCount={getGeneSnpCount("CYP1B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ESR1" {...geneGroupProps("ESR1", onGeneClick)}>
            <g id="gene-lozenge_32">
              <path
                d="M776 1120C776 1117.79 777.791 1116 780 1116H852C854.209 1116 856 1117.79 856 1120V1136C856 1138.21 854.209 1140 852 1140H780C777.791 1140 776 1138.21 776 1136V1120Z"
                fill={esr1.lozengeFill}
              />
              <text
                id="gene-label_32"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={801.569} y={1132.77}>
                  ESR1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="esr1"
              groupId="gene-snps_27"
              genePalette={esr1}
              startX={784}
              startY={1142}
              snpCount={getGeneSnpCount("ESR1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-ESR2" {...geneGroupProps("ESR2", onGeneClick)}>
            <g id="gene-lozenge_33">
              <path
                d="M937 1121C937 1118.79 938.791 1117 941 1117H1013C1015.21 1117 1017 1118.79 1017 1121V1137C1017 1139.21 1015.21 1141 1013 1141H941C938.791 1141 937 1139.21 937 1137V1121Z"
                fill={esr2.lozengeFill}
              />
              <text
                id="gene-label_33"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={961.305} y={1133.77}>
                  ESR2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="esr2"
              groupId="gene-snps_28"
              genePalette={esr2}
              startX={945}
              startY={1143}
              snpCount={getGeneSnpCount("ESR2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-COMT" {...geneGroupProps("COMT", onGeneClick)}>
            <g id="gene-lozenge_34">
              <path
                d="M518 1300C518 1297.79 519.791 1296 522 1296H594C596.209 1296 598 1297.79 598 1300V1316C598 1318.21 596.209 1320 594 1320H522C519.791 1320 518 1318.21 518 1316V1300Z"
                fill={comt.lozengeFill}
              />
              <text
                id="gene-label_34"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={537.848} y={1312.77}>
                  COMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="comt"
              groupId="gene-snps_29"
              genePalette={comt}
              startX={526}
              startY={1322}
              snpCount={getGeneSnpCount("COMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-COMT_2" {...geneGroupProps("COMT", onGeneClick)}>
            <g id="gene-lozenge_35">
              <path
                d="M659 1300C659 1297.79 660.791 1296 663 1296H735C737.209 1296 739 1297.79 739 1300V1316C739 1318.21 737.209 1320 735 1320H663C660.791 1320 659 1318.21 659 1316V1300Z"
                fill={comt.lozengeFill}
              />
              <text
                id="gene-label_35"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={678.848} y={1312.77}>
                  COMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="comt-2"
              groupId="gene-snps_30"
              genePalette={comt}
              startX={667}
              startY={1322}
              snpCount={getGeneSnpCount("COMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-UGT/SULT" {...geneGroupProps("UGT/SULT", onGeneClick)}>
            <g id="gene-lozenge_36">
              <path
                d="M509 1404C509 1401.79 510.791 1400 513 1400H603C605.209 1400 607 1401.79 607 1404V1420C607 1422.21 605.209 1424 603 1424H513C510.791 1424 509 1422.21 509 1420V1404Z"
                fill={ugt_sult.lozengeFill}
              />
              <text
                id="gene-label_36"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={525.324} y={1416.77}>
                  UGT/SULT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ugt-sult"
              groupId="gene-snps_31"
              genePalette={ugt_sult}
              startX={517}
              startY={1426}
              snpCount={getGeneSnpCount("UGT/SULT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-UGT/SULT_2" {...geneGroupProps("UGT/SULT", onGeneClick)}>
            <g id="gene-lozenge_37">
              <path
                d="M653 1404C653 1401.79 654.791 1400 657 1400H747C749.209 1400 751 1401.79 751 1404V1420C751 1422.21 749.209 1424 747 1424H657C654.791 1424 653 1422.21 653 1420V1404Z"
                fill={ugt_sult.lozengeFill}
              />
              <text
                id="gene-label_37"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={669.324} y={1416.77}>
                  UGT/SULT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ugt-sult-2"
              groupId="gene-snps_32"
              genePalette={ugt_sult}
              startX={661}
              startY={1426}
              snpCount={getGeneSnpCount("UGT/SULT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NQO1" {...geneGroupProps("NQO1", onGeneClick)}>
            <g id="gene-lozenge_38">
              <path
                d="M763 1400C763 1397.79 764.791 1396 767 1396H839C841.209 1396 843 1397.79 843 1400V1416C843 1418.21 841.209 1420 839 1420H767C764.791 1420 763 1418.21 763 1416V1400Z"
                fill={nqo1.lozengeFill}
              />
              <text
                id="gene-label_38"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={784.598} y={1412.77}>
                  NQO1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nqo1"
              groupId="gene-snps_33"
              genePalette={nqo1}
              startX={771}
              startY={1422}
              snpCount={getGeneSnpCount("NQO1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-UGT/SULT_3" {...geneGroupProps("UGT/SULT", onGeneClick)}>
            <g id="gene-lozenge_39">
              <path
                d="M393 1404C393 1401.79 394.791 1400 397 1400H487C489.209 1400 491 1401.79 491 1404V1420C491 1422.21 489.209 1424 487 1424H397C394.791 1424 393 1422.21 393 1420V1404Z"
                fill={ugt_sult.lozengeFill}
              />
              <text
                id="gene-label_39"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={409.324} y={1416.77}>
                  UGT/SULT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ugt-sult-3"
              groupId="gene-snps_34"
              genePalette={ugt_sult}
              startX={401}
              startY={1426}
              snpCount={getGeneSnpCount("UGT/SULT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP3A4" {...geneGroupProps("CYP3A4", onGeneClick)}>
            <g id="gene-lozenge_40">
              <path
                d="M400 1219C400 1216.79 401.791 1215 404 1215H479C481.209 1215 483 1216.79 483 1219V1235C483 1237.21 481.209 1239 479 1239H404C401.791 1239 400 1237.21 400 1235V1219Z"
                fill={cyp3a4.lozengeFill}
              />
              <text
                id="gene-label_40"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={416.098} y={1231.77}>
                  CYP3A4
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp3a4"
              groupId="gene-snps_35"
              genePalette={cyp3a4}
              startX={408}
              startY={1241}
              snpCount={getGeneSnpCount("CYP3A4", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD17B2" {...geneGroupProps("HSD17B2", onGeneClick)}>
            <g id="gene-lozenge_41">
              <path
                d="M608 1123C608 1120.79 609.791 1119 612 1119H691C693.209 1119 695 1120.79 695 1123V1139C695 1141.21 693.209 1143 691 1143H612C609.791 1143 608 1141.21 608 1139V1123Z"
                fill={hsd17b2.lozengeFill}
              />
              <text
                id="gene-label_41"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={624.156} y={1135.77}>
                  HSD17B2
                </tspan>
              </text>
              <path
                id="*_12"
                d="M704.875 1116.75V1118.48L702.199 1118.38L703.728 1120.69L702.228 1121.62L700.875 1119.12L699.522 1121.62L698.022 1120.69L699.551 1118.38L696.875 1118.48L696.875 1116.75L699.551 1116.85L698.022 1114.54L699.522 1113.62L700.875 1116.11L702.228 1113.62L703.728 1114.54L702.199 1116.85L704.875 1116.75Z"
                fill="black"
              />
            </g>
          </g>
          <g id="gene-AR" {...geneGroupProps("AR", onGeneClick)}>
            <g id="gene-lozenge_42">
              <path
                d="M917 850C917 847.791 918.791 846 921 846H993C995.209 846 997 847.791 997 850V866C997 868.209 995.209 870 993 870H921C918.791 870 917 868.209 917 866V850Z"
                fill={ar.lozengeFill}
              />
              <text
                id="gene-label_42"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={948.223} y={862.767}>
                  AR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ar"
              groupId="gene-snps_36"
              genePalette={ar}
              startX={925}
              startY={872}
              snpCount={getGeneSnpCount("AR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A2" {...geneGroupProps("SRD5A2", onGeneClick)}>
            <g id="gene-lozenge_43">
              <path
                d="M495 795C495 792.791 496.791 791 499 791H574C576.209 791 578 792.791 578 795V811C578 813.209 576.209 815 574 815H499C496.791 815 495 813.209 495 811V795Z"
                fill={srd5a2.lozengeFill}
              />
              <text
                id="gene-label_43"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={511.33} y={807.767}>
                  SRD5A2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a2"
              groupId="gene-snps_37"
              genePalette={srd5a2}
              startX={503}
              startY={817}
              snpCount={getGeneSnpCount("SRD5A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A2_2" {...geneGroupProps("SRD5A2", onGeneClick)}>
            <g id="gene-lozenge_44">
              <path
                d="M608 795C608 792.791 609.791 791 612 791H687C689.209 791 691 792.791 691 795V811C691 813.209 689.209 815 687 815H612C609.791 815 608 813.209 608 811V795Z"
                fill={srd5a2.lozengeFill}
              />
              <text
                id="gene-label_44"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={624.33} y={807.767}>
                  SRD5A2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a2-2"
              groupId="gene-snps_38"
              genePalette={srd5a2}
              startX={616}
              startY={817}
              snpCount={getGeneSnpCount("SRD5A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP19A1_2" {...geneGroupProps("CYP19A1", onGeneClick)}>
            <g id="gene-lozenge_45">
              <path
                d="M434 973C434 970.791 435.791 969 438 969H515C517.209 969 519 970.791 519 973V989C519 991.209 517.209 993 515 993H438C435.791 993 434 991.209 434 989V973Z"
                fill={cyp19a1.lozengeFill}
              />
              <text
                id="gene-label_45"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={450.496} y={985.767}>
                  CYP19A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp19a1-2"
              groupId="gene-snps_39"
              genePalette={cyp19a1}
              startX={442}
              startY={995}
              snpCount={getGeneSnpCount("CYP19A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_3" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_46">
              <path
                d="M616 506C616 503.791 617.791 502 620 502H696C698.209 502 700 503.791 700 506V522C700 524.209 698.209 526 696 526H620C617.791 526 616 524.209 616 522V506Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-label_46"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={632.399} y={518.767}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-3"
              groupId="gene-snps_40"
              genePalette={cyp17a1}
              startX={624}
              startY={528}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_4" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_47">
              <path
                d="M484 376C484 373.791 485.791 372 488 372H564C566.209 372 568 373.791 568 376V392C568 394.209 566.209 396 564 396H488C485.791 396 484 394.209 484 392V376Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-label_47"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={500.399} y={388.767}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-4"
              groupId="gene-snps_41"
              genePalette={cyp17a1}
              startX={492}
              startY={398}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <path
            id="Vector 326"
            d="M874.5 1170.5H873.8V1171.2H874.5V1170.5ZM892 1170.5H892.7V1169.8H892V1170.5ZM892 1185L896.041 1178H887.959L892 1185ZM874.5 1144.5H873.8V1170.5H874.5H875.2V1144.5H874.5ZM874.5 1170.5V1171.2H892V1170.5V1169.8H874.5V1170.5ZM892 1170.5H891.3V1178.7H892H892.7V1170.5H892Z"
            fill="#282828"
          />
          <path
            id="Vector 327"
            d="M919.5 1170.5H920.2V1171.2H919.5V1170.5ZM902 1170.5H901.3V1169.8H902V1170.5ZM902 1185L897.959 1178H906.041L902 1185ZM919.5 1144.5H920.2V1170.5H919.5H918.8V1144.5H919.5ZM919.5 1170.5V1171.2H902V1170.5V1169.8H919.5V1170.5ZM902 1170.5H902.7V1178.7H902H901.3V1170.5H902Z"
            fill="#282828"
          />
          <path
            id="Vector 322"
            d="M475 1071H474.3V1071.44L474.694 1071.63L475 1071ZM530.5 1098L525.973 1091.3L522.437 1098.57L530.5 1098ZM475 1007.5H474.3V1071H475H475.7V1007.5H475ZM475 1071L474.694 1071.63L524.529 1095.87L524.835 1095.24L525.141 1094.61L475.306 1070.37L475 1071Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 325"
            d="M744 1099.5L752.066 1098.98L747.583 1092.25L744 1099.5ZM771 1081.5V1080.8H770.788L770.612 1080.92L771 1081.5ZM923 1081.5H923.7V1080.8H923V1081.5ZM923 1115L927.041 1108H918.959L923 1115ZM873.5 1115L877.541 1108H869.459L873.5 1115ZM747.375 1097.25L747.763 1097.83L750.013 1096.33L749.625 1095.75L749.237 1095.17L746.987 1096.67L747.375 1097.25ZM751.875 1094.25L752.263 1094.83L754.513 1093.33L754.125 1092.75L753.737 1092.17L751.487 1093.67L751.875 1094.25ZM756.375 1091.25L756.763 1091.83L759.013 1090.33L758.625 1089.75L758.237 1089.17L755.987 1090.67L756.375 1091.25ZM760.875 1088.25L761.263 1088.83L763.513 1087.33L763.125 1086.75L762.737 1086.17L760.487 1087.67L760.875 1088.25ZM765.375 1085.25L765.763 1085.83L768.013 1084.33L767.625 1083.75L767.237 1083.17L764.987 1084.67L765.375 1085.25ZM769.875 1082.25L770.263 1082.83L771.388 1082.08L771 1081.5L770.612 1080.92L769.487 1081.67L769.875 1082.25ZM771 1081.5V1082.2H772.424V1081.5V1080.8H771V1081.5ZM775.271 1081.5V1082.2H778.118V1081.5V1080.8H775.271V1081.5ZM780.965 1081.5V1082.2H783.812V1081.5V1080.8H780.965V1081.5ZM786.66 1081.5V1082.2H789.507V1081.5V1080.8H786.66V1081.5ZM792.354 1081.5V1082.2H795.201V1081.5V1080.8H792.354V1081.5ZM798.049 1081.5V1082.2H800.896V1081.5V1080.8H798.049V1081.5ZM803.743 1081.5V1082.2H806.59V1081.5V1080.8H803.743V1081.5ZM809.438 1081.5V1082.2H812.285V1081.5V1080.8H809.438V1081.5ZM815.132 1081.5V1082.2H817.979V1081.5V1080.8H815.132V1081.5ZM820.826 1081.5V1082.2H823.674V1081.5V1080.8H820.826V1081.5ZM826.521 1081.5V1082.2H829.368V1081.5V1080.8H826.521V1081.5ZM832.215 1081.5V1082.2H835.062V1081.5V1080.8H832.215V1081.5ZM837.91 1081.5V1082.2H840.757V1081.5V1080.8H837.91V1081.5ZM843.604 1081.5V1082.2H846.451V1081.5V1080.8H843.604V1081.5ZM849.299 1081.5V1082.2H852.146V1081.5V1080.8H849.299V1081.5ZM854.993 1081.5V1082.2H857.84V1081.5V1080.8H854.993V1081.5ZM860.687 1081.5V1082.2H863.535V1081.5V1080.8H860.687V1081.5ZM866.382 1081.5V1082.2H869.229V1081.5V1080.8H866.382V1081.5ZM872.076 1081.5V1082.2H873.5V1081.5V1080.8H872.076V1081.5ZM873.5 1081.5V1082.2H874.875V1081.5V1080.8H873.5V1081.5ZM877.625 1081.5V1082.2H880.375V1081.5V1080.8H877.625V1081.5ZM883.125 1081.5V1082.2H885.875V1081.5V1080.8H883.125V1081.5ZM888.625 1081.5V1082.2H891.375V1081.5V1080.8H888.625V1081.5ZM894.125 1081.5V1082.2H896.875V1081.5V1080.8H894.125V1081.5ZM899.625 1081.5V1082.2H902.375V1081.5V1080.8H899.625V1081.5ZM905.125 1081.5V1082.2H907.875V1081.5V1080.8H905.125V1081.5ZM910.625 1081.5V1082.2H913.375V1081.5V1080.8H910.625V1081.5ZM916.125 1081.5V1082.2H918.875V1081.5V1080.8H916.125V1081.5ZM921.625 1081.5V1082.2H923V1081.5V1080.8H921.625V1081.5ZM923 1081.5H922.3V1082.9H923H923.7V1081.5H923ZM923 1085.69H922.3V1088.48H923H923.7V1085.69H923ZM923 1091.27H922.3V1094.06H923H923.7V1091.27H923ZM923 1096.85H922.3V1099.65H923H923.7V1096.85H923ZM923 1102.44H922.3V1105.23H923H923.7V1102.44H923ZM923 1108.02H922.3V1110.81H923H923.7V1108.02H923ZM873.5 1081.5H872.8V1082.9H873.5H874.2V1081.5H873.5ZM873.5 1085.69H872.8V1088.48H873.5H874.2V1085.69H873.5ZM873.5 1091.27H872.8V1094.06H873.5H874.2V1091.27H873.5ZM873.5 1096.85H872.8V1099.65H873.5H874.2V1096.85H873.5ZM873.5 1102.44H872.8V1105.23H873.5H874.2V1102.44H873.5ZM873.5 1108.02H872.8V1110.81H873.5H874.2V1108.02H873.5Z"
            fill="#818181"
          />
        </g>
      </g>
    </>
  );
};

const SvgEndocrineOverviewDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1344}
    viewBox="0 204 1024 1344"
    fill="none"
    {...props}
  >
    <EndocrineOverviewDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_224300">
        <rect width={1024} height={1548} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_224300">
        <rect width={1024} height={1344} fill="white" transform="translate(0 204)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEndocrineOverviewDiagram;
